import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const TableFilterIconGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M14.1335 2.01605H2.01562L6.67634 8.54105V14.1339L9.47277 12.2696V8.54105L14.1335 2.01605Z"
        fill={fillColor}
      />
    </g>
  );
};

export const TableFilterIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...(props.svg ?? {})}
    >
      <TableFilterIconGroup {...props} />
    </svg>
  );
};
